import { render, staticRenderFns } from "./TelephoneTalkWorkCountChart.vue?vue&type=template&id=c2082b08"
import script from "./TelephoneTalkWorkCountChart.vue?vue&type=script&lang=js"
export * from "./TelephoneTalkWorkCountChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports